import styled from "styled-components"

import {IconButton} from "@irati/ui/src/Button"
import {IconTypes} from "@irati/ui/src/Icon"

interface WrapperButton {
  currentStep?: number
}

export const Back = styled(IconButton).attrs({icon: IconTypes.chevronLeft, size: 12})<WrapperButton>`
  visibility: ${({currentStep}) => (currentStep > 0 ? "visible" : "hidden")};
  ${({theme}) => `
    position: absolute;
    top: ${theme.spacing.two};
    left: ${theme.spacing.two};
    margin-bottom: -12px;
    ${theme.mediaQueries.minWidthMedia.tablet`
      left: ${theme.spacing.three};
    `}
  `}
`
